import Vue from 'vue';
import tileContainer from './shared/TileContainer.vue';
import auditInfo from './shared/AuditInfo.vue';
import documentBox from './selectors/DocumentBox.vue';
import datePicker from './shared/DatePicker.vue';
import dialogEdit from './commands/DialogEdit.vue';
const components = {
    tileContainer,
    auditInfo,
    documentBox,
    datePicker,
    dialogEdit
};

Object.entries(components).forEach(([name, component]) => Vue.component(name, component));